import PropTypes from 'prop-types';

import React from 'react';

import Wrapper from './Wrapper';
import Position from './Position';
import Handle from './Handle';

export default class BlockOrder extends React.PureComponent {
  state = {
    index: this.props.index,
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.index !== this.props.index || nextProps.index !== this.state.index) {
      this.setState({ index: nextProps.index });
    }
  }

  handleIndexChange = (e) => {
    if (!/^\d*$/.test(e.target.value)) {
      return;
    }

    const index = Number(e.target.value);

    if (index > this.props.maxIndex) {
      return;
    }

    this.setState({ index: index || '' });
  }

  handleIndexSubmit = (e) => {
    if (e.key !== 'Enter') {
      return;
    }

    const newIndex = Number(this.state.index);

    if (newIndex > 0) {
      this.props.onIndexChange(newIndex - 1);
    }
  }

  handleBlur = () => {
    // restore removed index in input field
    if (!this.state.index) {
      this.setState({ index: this.props.index });
    }
  }

  render() {
    return (
      <Wrapper>
        <Position
          value={this.state.index}
          isActive={this.props.isActive}
          isValid={this.props.isValid}
          onChange={this.handleIndexChange}
          onKeyPress={this.handleIndexSubmit}
          onBlur={this.handleBlur}
        />

        {this.props.connectDragSource(
          <div>
            <Handle title="Переместить блок">
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="9" viewBox="0 0 17 9">
                <path fill="#fff" fillRule="evenodd" d="M0 0L17 0 17 1 0 1 0 0ZM0 4L17 4 17 5 0 5 0 4ZM0 8L17 8 17 9 0 9 0 8Z" />
              </svg>
            </Handle>
          </div>
        )}
      </Wrapper>
    );
  }
}

BlockOrder.propTypes = {
  index: PropTypes.number.isRequired,
  maxIndex: PropTypes.number,
  isActive: PropTypes.bool,
  isValid: PropTypes.bool,
  connectDragSource: PropTypes.func.isRequired,
  onIndexChange: PropTypes.func,
};
